import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Breadcrumb } from "../breadcrumb";
export const EmptyView = observer(({ message }) => {
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsx(Breadcrumb, {}), _jsxs("div", { className: "card mb-5", children: [_jsx("h6", { className: "card-header pt-3 pb-3", children: t("empty.title") }), _jsx("div", { className: "card-body", children: message })] })] }));
});
